import { NewsVerbose } from '@lc/card/verbose/NewsVerbose';
import { recharge1 } from '@lc/const/modifiers';
import { GameState } from '@lc/interface/gameState/types';
import { act_player } from '@lc/interface/player/action';

class NewsController {
	async flipNews(gameState: GameState, ticker: string[]) {
		// refill factories, THEN run news to see if anyone needs to get their energy SUBTRACTED
		for (const p of gameState.playerStateArray) {
			act_player.refillFactories(p);

			if (p.modifiers.includes(recharge1)) {
				act_player.refillBattery(p);
			}
		}

		const newsId = gameState.DeckNews.shift() || 0;
		const currNews = NewsVerbose[newsId];
		currNews.action(gameState);
		gameState.seasonalNewsCards.push(newsId);
		ticker.unshift(
			`News card ${newsId}: ${currNews.title} || ${currNews.description}`
		);
	}
}

export const controller_news = new NewsController();
